import type { ReactElement } from "react";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { styled } from "@mui/material/styles";
import { ERROR_CODES } from "../../../../lib/errors";
import type { ErrorCode } from "../../../../lib/errors";

const ErrorIcon = styled(ErrorOutlineOutlinedIcon)(({ theme }) => ({
  fontSize: 64,
  color: theme.palette.text.disabled,
}));

const RobotIcon = styled(SmartToyOutlinedIcon)(({ theme }) => ({
  fontSize: 64,
  color: theme.palette.text.disabled,
}));

/** code → icon. Not translatable content, so it lives here rather than en.json — title and
 *  description text is sourced from en.json's "errors" namespace (see useErrorState). */
export function iconForErrorCode(code: ErrorCode): ReactElement {
  switch (code) {
    case ERROR_CODES.LLM.PROVIDER_UNAVAILABLE:
    case ERROR_CODES.LLM.RATE_LIMITED:
    case ERROR_CODES.LLM.AUTH_ERROR:
    case ERROR_CODES.RATE_LIMIT.EXCEEDED:
      return <RobotIcon />;
    default:
      return <ErrorIcon />;
  }
}
